import React from "react";
import dynamic from "next/dynamic";
import Drawer from "./Drawer";
const AddressForm = dynamic(() => import('./pages/customers/AddressForm'), {ssr: false})


const AddressDrawer = ({
    title,
    address,
    onSave,
    onClose,
    addressId,
    updateEmail,
    submitText="Save"
}) => (
    <Drawer
        title={title}
        onClose={onClose}>
        <AddressForm
            value={address}
            onCancel={onClose}
            onSubmit={(event) => {
                onSave(event);
                onClose();
            }}
            addressId={addressId}
            updateEmail={updateEmail}
            submitText={submitText}
            editOnly
        />
    </Drawer>
);

export default AddressDrawer;
